import { HeadingProps } from '@chakra-ui/react';
import { Heading } from 'components/UI';

const PageTitle = ({ children, ...props }: HeadingProps) => (
  <Heading as="h1" fontWeight="medium" fontSize="5xl" letterSpacing="wide" color="gray.900" {...props}>
    {children}
  </Heading>
);

export { PageTitle };
